// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice'; // Assurez-vous que votre slice existe
import categoryReducer from './slices/categorySlice';
import blocsReducer from './slices/blocsReducer';
import searchReducer from './slices/searchSlice';
import faqsReducer from './slices/faqsSlice';
import etablissementReducer from './slices/etablissementSlice';
import favoritesReducer from './slices/favorisSlice';
import rendrezvousReducer from './slices/rendezVousSlice';
import reviewsReducer from './slices/review';
import paymentReducer from './slices/methodePaymentSlice';
import rendezvousPrestaReducer from './slices/rendezVousPrestaSlice';
import avisReducer from './slices/avisSlice';
import kpiReducer from './slices/kpiSlice';
import blogRReducer from './slices/blogSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    categories: categoryReducer,
    blocs: blocsReducer,
    search: searchReducer,
    faqs: faqsReducer,
    etablissements: etablissementReducer,
    favorites: favoritesReducer,
    rendezvous: rendrezvousReducer, 
    reviews: reviewsReducer,
    payment: paymentReducer,
    rdvPresta : rendezvousPrestaReducer,
    avisClient : avisReducer,
    kpi : kpiReducer,
    blog : blogRReducer,
  
  },
});

export default store;
